<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <div class="mb-3">
        <vs-input :label="$t('category_name')" :placeholder="$t('category_name')" v-model="categoryFormData.title" class="w-full mb-3"/>
      </div>
      <div class="mb-3">
        <vs-input :label="$t('description')" :placeholder="$t('description')" v-model="categoryFormData.description" class="w-full"/>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/../eventbus'
import MessageCategory from '@/models/MessageCategory'

export default {
  name: 'Shared.Messages.Category.Add',
  data () {
    return {
      categoryFormData: {
        title: '',
        description: ''
      },
      categoryFormErrors: []
    }
  },
  mounted () {
    EventBus.$on('initMessageCategoryFormData', this.initMessageCategoryFormData)
    EventBus.$on('initAddMessageCategory', this.addMessageCategory)
  },
  methods: {
    initMessageCategoryFormData () {
      this.categoryFormData = {
        title: '',
        description: ''
      }
      this.categoryFormErrors = {}
    },
    async addMessageCategory () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#addMessageCategoryButton', scale: 0.45})
      try {
        if (!this.$store.getters.isFormInProgress) {
          this.$store.dispatch('setIsFormInProgress', true)
          await MessageCategory.store(this.categoryFormData)

          this.initMessageCategoryFormData()
          this.$emit('addMessageCategorySuccess')
          this.$store.dispatch('setIsFormInProgress', false)
        }
      } catch (e) {
        if (this.categoryFormData.title.trim().length === 0 && this.categoryFormData.description.trim().length === 0) {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: this.$t('add_message_category_error_message_if_empty_title_and_empty_description'),
            confirmButton: this.$t('confirm')
          })
        } else if (this.categoryFormData.title.trim().length === 0) {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: this.$t('add_message_category_error_message_if_empty_title'),
            confirmButton: this.$t('confirm')
          })
        } else if (this.categoryFormData.description.trim().length === 0) {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: this.$t('add_message_category_error_message_if_empty_description'),
            confirmButton: this.$t('confirm')
          })
        }
        this.$store.dispatch('setIsFormInProgress', false)
      }
      this.$vs.loading.close('#addMessageCategoryButton > .con-vs-loading')

    }
  }
}
</script>

<style lang="scss">
  #addMessageCategoryButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
